// Client bundle implementation of the device ID context.
//
// On the client there is a single user per process, so a module-level
// variable is sufficient. This file intentionally does NOT import
// `async_hooks` so the client bundle stays free of the Node builtin.
// See config/rspack/client.{dev,prod}.js for the
// NormalModuleReplacementPlugin that rewrites `@/network/deviceIdContext`
// to this file in the client build.

let clientDeviceId: string | null = null;

/** CLIENT: Set the device ID globally. Call once on hydration. */
export function setDeviceId(deviceId: string | undefined | null): void {
    clientDeviceId = deviceId ?? null;
}

/** Read the current device ID. Returns null until setDeviceId() is called. */
export function getDeviceId(): string | null {
    return clientDeviceId;
}
